export default "__VITE_ASSET__D8JG$slZ__"